import { Link } from 'react-router-dom'

/**
 * App icon for the home screen grid.
 * Panerai-inspired: dark dial with glowing lume indices.
 * Icons "glow" teal like watch indices against dark background.
 */
export default function AppIcon({ to, icon: Icon, label, color, badge }) {
  // In dark mode: dark surface with teal icon (like lume indices on dial)
  // In light mode: use provided color or default
  const lightBg = color || 'bg-primary-600'

  return (
    <Link
      to={to}
      className="flex flex-col items-center gap-2 p-2 active:scale-95 transition-all group"
    >
      <div className={`relative w-16 h-16 ${lightBg} dark:bg-dial-elevated rounded-2xl flex items-center justify-center shadow-md dark:shadow-none dark:border dark:border-dial-border group-hover:shadow-lg dark:group-hover:border-lume-teal/50 transition-all`}>
        <Icon className="w-8 h-8 text-white dark:text-lume-teal transition-colors" />
        {badge > 0 && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-status-error dark:bg-lume-teal text-white dark:text-dial-black text-xs font-bold rounded-full flex items-center justify-center">
            {badge > 9 ? '9+' : badge}
          </span>
        )}
      </div>
      <span className="text-xs font-medium text-gray-600 dark:text-indices-medium text-center group-hover:text-gray-900 dark:group-hover:text-lume-teal transition-colors">{label}</span>
    </Link>
  )
}
